<template>
  <div>
    <div class="apply-page" v-if="isShowPage">
      <SetNavBar :typeId="typeId" :step="step"></SetNavBar>
      <div class="apply-title-center content-page">
        <div class="title_left">
          <img
            class="hos-logo"
            v-if="isJustShowLogo == false"
            :src="hosParams.hosLogoUrl"
          />
          <div class="hosName" v-if="isJustShowLogo == false">
            <div class="title">{{ hosParams.hospitalPreName }}</div>
            <div class="title">{{ hosParams.hospitalPostName }}</div>
          </div>
          <img
            v-if="isJustShowLogo"
            class="hosLogo"
            src="../assets/sxdeyy.png"
          />
          <div id="iconLight" style="margin-left: 5px" @click="showNoticeClick">
            <div class="ann">公告</div>
          </div>
        </div>
        <router-link class="title_right" to="/hos-list" @click="choosHospital">
          <div class="selHos">选择医院</div>
        </router-link>
      </div>
      <div class="multi-hos_tips" v-if="isShowDistrictBtn">
        <div class="multi-hos_tips_content">【提示】如果不是此院区，可</div>
        <div class="select_hos" @click="switchDistrict">【切换院区】</div>
      </div>
      <div class="multi-hos_tips" v-if="isShowServiceBtn">
        <div class="multi-hos_tips_content">【提示】</div>
        <div class="select_hos" @click="switchService">【切换服务】</div>
      </div>
      <!-- 温馨提示窗口办理 -->
      <div v-if="noApply == true">
        <div v-html="imHtml" class="contentview" />
      </div>

      <!-- 业务选择类型 -->
      <div v-if="noApply == false">
        <div class="weui-cells__title">业务类型选择</div>
        <div class="weui-cells weui-cells_after-title">
          <div class="weui-cell radio-content">
            <div
              :class="workId == item.id ? 'btn-print-select' : 'btn-print'"
              v-for="(item, index) in itemsWork"
              :key="'work' + index"
              @click="selectWorkType(item, index)"
            >
              {{ item.name }}
              <img class="select-icon" src="../assets/Oval_3.png" />
            </div>
          </div>
        </div>
        <div class="weui-cells__title">获取方式</div>
        <div class="weui-cells weui-cells_after-title">
          <div class="weui-cell radio-content">
            <div
              :class="[
                tid == item.id ? 'btn-print-select' : 'btn-print',
                item.name == '病案预约' ? 'no_display' : '',
              ]"
              v-for="(item, index) in expressType"
              :key="'type' + index"
              @click="selectTheWay(item, index)"
            >
              {{ item.name }}
              <img class="select-icon" src="../assets/Oval_3.png" />
            </div>
          </div>
          <!-- <div class="line"></div> -->
        </div>
        <DescInfo :show="showDescPickUp" :content="pickupTips"></DescInfo>
        <div v-if="showPickupRadio">
          <div class="weui-cells__title">选择自提地点</div>
          <div class="pickup-location">
            <van-radio-group v-model="radio" class="raido-group-pickup">
              <van-radio
                :name="index"
                checked-color="#07c160"
                class="radio-pickup"
                @click="pickRaido(item)"
                v-for="(item, index) in hbPickPlaces"
                :key="'pickAddress' + index"
              >
                <div class="pick_name">{{ item.shortName }}</div>
                <div class="pick_address">
                  <img class="location_img" src="../assets/location_logo.svg" />
                  {{ item.desc }}
                </div>
              </van-radio>
            </van-radio-group>
          </div>
        </div>
        <DescInfo :show="showBrowseTips" :content="browseTips"></DescInfo>
        <div v-if="showDescExpress" style="display: inline">
          <span class="desc_cell" style="color: red"
            >隐私政策用途：当您选择邮寄到家，我们会收集您的收件人姓名、收件电话、收件的详细地址，如果您不提供，您将无法使用邮寄到家业务。</span
          >
        </div>
        <DescInfo :show="showDescExpress" :content="hosExpressDesc">
          <template v-slot:desc>
            <div>
              <span>为保证及时收到，请确保以下填写信息准确无误！</span>
              <span v-if="showExpressFlag">
                快递业务由
                <img
                  class="express-img"
                  v-if="expressFlag == 'EMS'"
                  src="../assets/ems.png"
                />
                <img
                  class="express-img"
                  v-if="expressFlag == 'SF'"
                  src="../assets/sf.png"
                />
                <img
                  class="express-img"
                  v-if="expressFlag == 'ANE'"
                  src="../assets/ane.png"
                />
                <img
                  class="express-img"
                  v-if="expressFlag == 'JD'"
                  src="../assets/jd_logo.png"
                />
                <img
                  class="express-img"
                  v-if="expressFlag == 'ZGYZ'"
                  src="../assets/ZGYZ.png"
                />
                <img
                  class="express-img"
                  v-if="expressFlag == 'STO'"
                  src="../assets/ST.png"
                />
                <img
                  class="express-img"
                  v-if="expressFlag == 'YD'"
                  src="../assets/YD.png"
                />
                <img
                  class="express-img"
                  v-if="expressFlag == 'ZTO'"
                  src="../assets/ZTO.png"
                />
                <img
                  class="express-img"
                  v-if="expressFlag == 'SFDL'"
                  src="../assets/sf.png"
                />
                （{{ expressDispName }}）承揽
              </span>
            </div>
          </template>
        </DescInfo>
        <div class="weui-cells weui-cells_form" v-if="showAddressInfo">
          <div class="weui-cell" v-if="showExpressList">
            <div class="weui-cell__hd express-title">
              <div class="weui-label title">快递公司</div>
            </div>
            <div class="weui-cell__bd">
              <van-radio-group v-model="radio2" class="express-radio">
                <van-radio
                  checked-color="#07c160"
                  :name="index"
                  v-for="(item, index) in expressItems"
                  :key="'radio2' + index"
                  @click="selectExpress(item)"
                >
                  <img
                    class="express-logo"
                    v-if="item.expressFlag == 'EMS'"
                    src="../assets/ems.png"
                  />
                  <img
                    class="express-logo"
                    v-if="item.expressFlag == 'SF'"
                    src="../assets/sf.png"
                  />
                  <img
                    class="express-logo"
                    v-if="item.expressFlag == 'TT'"
                    src="../assets/tiantian.png"
                  />
                  <img
                    class="express-logo"
                    v-if="item.expressFlag == 'JD'"
                    src="../assets/jd_logo.png"
                  />
                  <img
                    class="express-logo"
                    v-if="item.expressFlag == 'ZGYZ'"
                    src="../assets/ZGYZ.png"
                  />
                  <img
                    class="express-logo"
                    v-if="item.expressFlag == 'ANE'"
                    src="../assets/ane.png"
                  />
                  <img
                    class="express-logo"
                    v-if="item.expressFlag == 'SFDL'"
                    src="../assets/sf.png"
                  />
                  <img
                    class="express-logo"
                    v-if="item.expressFlag == 'STO'"
                    src="../assets/ST.png"
                  />
                  <img
                    class="express-logo"
                    v-if="item.expressFlag == 'YD'"
                    src="../assets/YD.png"
                  />
                  <img
                    class="express-logo"
                    v-if="item.expressFlag == 'ZTO'"
                    src="../assets/ZTO.png"
                  />
                </van-radio>
              </van-radio-group>
            </div>
          </div>

          <div class="line-left"></div>
          <div class="van-address-edit__fields">
            <div class="van-cell van-field">
              <div class="van-cell__title van-field__label">
                <span>收件人姓名</span>
              </div>
              <div class="van-cell__value">
                <div class="van-field__body">
                  <input
                    type="text"
                    placeholder="请输入收件人姓名"
                    v-model.trim="name"
                    class="van-field__control"
                  />
                </div>
              </div>
            </div>
            <div class="van-cell van-field">
              <div class="van-cell__title van-field__label">
                <span>收件人电话</span>
              </div>
              <div class="van-cell__value">
                <div class="van-field__body">
                  <input
                    type="tel"
                    placeholder="请输入收件人电话"
                    v-model.trim="phoneNum"
                    @input="watchNum"
                    class="van-field__control"
                  />
                  <div
                    class="van-field__right-icon"
                    v-if="isShowPhoneAlert"
                    @click="showErrorMsg('phone')"
                  >
                    <i class="van-icon van-icon-info-o">
                      <!---->
                    </i>
                  </div>
                </div>
              </div>
            </div>

            <!-- 省市区选择 -->
            <div
              class="van-cell van-cell--clickable van-field"
              @click="showPopAddress"
            >
              <div class="van-cell__title van-field__label">
                <span>所在地区</span>
              </div>
              <div class="van-cell__value">
                <div class="van-field__body">
                  <input
                    type="text"
                    placeholder="选择省 / 市 / 区"
                    v-model="area"
                    readonly="readonly"
                    class="van-field__control"
                  />
                  <div class="van-field__right-icon">
                    <i class="van-icon van-icon-arrow">
                      <!---->
                    </i>
                  </div>
                </div>
              </div>
            </div>

            <!-- 省市区选择 -->
            <!-- 新省市区选择 -->
            <!--居住地址三级联动选项-->
            <section class="showChose" v-show="showChose">
              <section class="address">
                <section class="title1 jusbetween">
                  <span class="tipadd">请选择邮寄地址
                    <span class="greentip">(点击绿色字体可切换)</span>
                  </span>
                  <span @click="closeAdd()">×</span>
                </section>
                <section class="title1 selectarea">
                  <div class="area" @click="provinceSelected()" :class="Province ? '' : 'active'">
                    <!-- {{ Province ? Province : info[province - 1].name }} -->
                    {{ Province ? Province : '请选择' }}
                  </div>
                  <div
                    class="area"
                    @click="citySelected()"
                    :class="City ? '' : 'active'"
                     v-show="Province"
                  >
                    {{ City ? City : "请选择" }}
                  </div>
                  <div
                    class="area"
                    @click="districtSelected()"
                    :class="District ? '' : 'active'"
                    v-show="City"
                  >
                    {{ District ? District : "请选择" }}
                  </div>
                </section>
                <ul>
                  <li
                    class="addList"
                    :key="v.id"
                    v-for="(v, k) in info"
                    @click="getProvinceId(v.id, v.name, k)"
                    v-show="showProvince"
                    :class="v.selected ? 'active' : ''"
                  >
                    {{ v.name }}
                  </li>
                  <li
                    class="addList"
                    :key="v.id"
                    v-for="(v, k) in showCityList"
                    @click="getCityId(v.id, v.name, k)"
                    v-show="showCity"
                    :class="v.selected ? 'active' : ''"
                  >
                    {{ v.name }}
                  </li>
                  <li
                    class="addList"
                    :key="v.id"
                    v-for="(v, k) in showDistrictList"
                    @click="getDistrictId(v.id, v.name, k)"
                    v-show="showDistrict"
                    :class="v.selected ? 'active' : ''"
                  >
                    {{ v.name }}
                  </li>
                </ul>
              </section>
            </section>
            <!-- 新省市区选择 -->

            <van-cell-group>
              <van-field
                v-model.trim="message"
                rows="1"
                autosize
                label="详细地址"
                type="textarea"
                placeholder="如街道、小区、门牌号、楼栋号、单元室（省市区请在上面选择，不要手动输入）"
              />
            </van-cell-group>
          </div>
        </div>
        <div class="bottom-view"></div>
        <van-button
          type="primary"
          size="large"
          class="btn-next"
          safe-area-inset-bottom
          @click="next"
          color="#1aad19"
          >下一步</van-button
        >
      </div>
      <!-- 业务类型 -->
      <!-- 公告 -->
      <div class="overlay" id="overlayId" v-if="showOverlay">
        <div class="floatDiv">
          <img
            class="close-float"
            v-if="isShowClose"
            @click="closePopDialog"
            src="../assets/close.svg"
          />

          <button
            class="closeTimer"
            v-if="isShowTimer"
            @click="closeTimer"
            :disabled="isTimerDisabled"
          >
            <div class="timerContent">{{ timerNum }}</div>
          </button>

          <div class="notice" id="noticeId">
            <div class="notice-titles" v-if="!isJustShowLogo">
              <img
                class="hos-logo2"
                v-if="hosNoticeLogo"
                :src="hosNoticeLogo"
              />
              <div class="notice-title">
                <div class="notice-title-hosName">{{ hospitalPreName }}</div>
                <div class="notice-title-hosName">{{ hospitalPostName }}</div>
              </div>
            </div>
            <div class="notice-titles" v-if="isJustShowLogo">
              <img class="hosLogo2" src="../assets/sxdeyy.png" />
            </div>

            <div class="weui-loadmore weui-loadmore_line">
              <div class="weui-loadmore__tips weui-loadmore__tips_in-line">
                申请须知
              </div>
            </div>
            <div v-html="html" id="contentId" class="contentview" />
            <van-checkbox
              class="check-agree"
              @change="checkboxChange"
              v-model="checked"
              shape="square"
              :disabled="isCheckDisabled"
              checked-color="#1aad19"
              v-if="isShowAgree"
              >我已知晓并同意上述内容</van-checkbox
            >
            <van-button
              type="primary"
              color="#1aad19"
              @click="confirmNotice"
              class="btn_confirm"
              block
              :disabled="isDisabled"
              v-if="isShowConfirm"
              >{{ confirmText }}</van-button
            >
          </div>
        </div>
      </div>
      <!-- 公告 -->
    </div>

    <!-- 医院分区界面 -->
    <div class="hos-district" v-if="isShowDistrict">
      <div class="multi-hospital">
        <div class="apply-title-center2">
          <div class="title_left">
            <img
              class="hos-logo multi-hos_logo"
              :src="hospitalParam.hosLogoUrl"
            />
            <div class="title multi-hos_title">{{ hosName }}</div>
          </div>
          <router-link class="title_right" to="/hos-list">
            <div class="selHos">选择医院</div>
          </router-link>
        </div>
        <div class="apply-title-center">
          <div class="hos_warn">{{ hospitalParam.desc }}</div>
        </div>
        <div class="weui-cells__title">申请院区</div>
        <div
          class="multi-hos"
          v-for="(item, index) in itemsDis"
          :key="'hos' + index"
          @click="selectHos(item.hosId)"
        >
          <div class="multi-hospital-cell">
            <div class="logo_cell">
              <img class="logo_content" :src="item.hosLogoUrl" />
            </div>
            <div class="multi-hos_content">
              <div class="multi-hos_title">{{ item.hosName }}</div>

              <div class="hos_item_type">
                <div
                  v-for="(item, index) in item.hBusinessLevelTwo"
                  :key="'type1' + index"
                >
                  <div class="expressType2">{{ item.name }}</div>
                </div>
                <div
                  v-for="(item, index) in item.hBusinessLevelThree"
                  :key="'type2' + index"
                >
                  <div class="expressType1">{{ item.name }}</div>
                </div>
                <!-- <view class='expressType2'>门诊病例</view> -->
              </div>
              <div class="multi-hos_address">
                <img class="address_logo" src="../assets/address.svg" />
                <div class="hos_item_address">{{ item.hosAddr }}</div>
              </div>
            </div>
          </div>
          <div class="zhushi">
            <span class="text_head">注:</span
            >申请需要输入住院号、入院时间、出院时间、患者姓名、证件号、手机号等。
          </div>
        </div>
      </div>
    </div>
    <!-- 服务界面 -->
    <div class="float-mr_type" v-if="isShowService">
      <div class="hos_info">
        <img class="hos_logo_big" :src="he.hosLogoUrl" />
        <div class="hos_name">{{ he.hosShortName }}</div>
        <router-link class="switch_btn" to="/hos-list">
          <van-button type="primary" size="small">更换医院</van-button>
        </router-link>
      </div>
      <div class="multi-hos_tips" v-if="isShowDistrictBtn">
        <div class="multi-hos_tips_content">【提示】如果不是此院区，可</div>
        <div class="select_hos" @click="switchDistrict">【切换院区】</div>
      </div>

      <div class="mr_type_cell">
        <div class="mrType_desc">确保医院信息无误，选择下方服务项目</div>
        <div
          class="mr_cell"
          v-for="item in hmrtsList"
          :key="item.code"
          @click="selectService(item.code)"
        >
          <div :class="item.className">
            <img
              v-if="item.code == 1"
              class="mr_item_icon"
              src="../assets/chm.svg"
            />
            <img
              v-if="item.code == 2"
              class="mr_item_icon"
              src="../assets/mr_express.svg"
            />
            <img
              v-if="item.code == 3"
              class="mr_item_icon"
              src="../assets/mr_look.svg"
            />
            <div class="mr_item_name">{{ item.desc }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
let selectHbsType = {};
let hosDispWaitTime = "";
let pickUpDesc = "";
let pickupOut = "";
let hosSelectExpressId = 0;
let hosConfig = {};
let hosId;
let timer, timer2;
let mode;
let count;
let hosItem = {};
let hosList = [];
let arrMedical = [];
let workArray = [];
let parentHosId;
let guideBId;
let expressId;
let selectExpressType;
let infoFlag = false; //获取方式选择标记false标识未选择
let selfPickupPlace;
let typeId;
let province, city, district;
let provinceCode, cityCode, districtCode;
let defaultAddress;
let displayOption;
import axios from 'axios';
import SetNavBar from "../components/SetNavBar.vue";
import DescInfo from "../components/DescInfo.vue";
import cityList from "../utils/city.js";
import Vue from "vue";
import { mapState } from "vuex";
import {
  RadioGroup,
  Radio,
  Area,
  Popup,
  Field,
  Cell,
  CellGroup,
  Button,
  Checkbox,
  CountDown,
  Notify,
  Dialog,
} from "vant";
Vue.use(Button)
  .use(RadioGroup)
  .use(Radio)
  .use(Area)
  .use(Popup)
  .use(Field)
  .use(Cell)
  .use(CellGroup)
  .use(Checkbox)
  .use(CountDown)
  .use(Dialog)
  .use(Notify);
export default {
  name: "apply",
  data() {
    return {
      // itemsWork: [],

      workId: "",
      tid: "",
      hosInfo: {},
      expressType: [],
      showDescPickUp: false,
      pickupTips: "",
      showDescExpress: false,
      hosExpressDesc: "",
      showExpressFlag: false,
      expressDispName: "",
      showBrowseTips: false, //是否显示病案浏览描述文字
      browseTips: "",
      showExpressList: false,
      radio: 0,
      radio2: "",
      expressItems: [],
      searchResult: [],
      showAddressInfo: false,
      message: "",
      show: false,
      hbPickPlaces: [],
      showPickupRadio: false,
      showOverlay: false,
      isShowClose: false,
      isShowTimer: false,
      isShowAgree: false,
      isShowConfirm: false,
      timerNum: 3,
      hosNoticeLogo: "",
      html: "",
      imHtml: "",

      checked: false,
      isDisabled: false,
      isTimerDisabled: false,
      confirmText: "确定",
      isCheckDisabled: true,
      isShowPage: false,
      typeId: "2",
      isShowServiceBtn: false,
      isShowDistrictBtn: false,
      hosExppress: {},
      // parentHosId: '',
      limitStatus: "",
      limitDayStatus: "",
      hosParams: {},
      itemsWork: [],
      expressFlag: "",
      name: "",
      phoneNum: "",
      area: "",
      isShowPhoneAlert: false,
      addressInfoFlag: false,
      selectUseExpressType: {},
      step: 1,
      hospitalPreName: "",
      hospitalPostName: "",
      isJustShowLogo: false,
      isShowService: false,
      isShowDistrict: false,
      itemsDis: [],
      hosName: "",
      hmrtsList: [],
      he: {},
      hospitalParam: {},
      noApply: false,

      // 新地址选择
      showChose: false,
      showProvince: true,
      showCity: false,
      showDistrict: false,
      showCityList: false,
      showDistrictList: false,
      province: '',
      provinceName:'',
      cityName:'',
      districtName:'',
      city: 3,
      district: 57,
      GetProvinceId: 2,
      District: false,
      Province: false,
      City: false,
      // v-for循环判断是否为当前
      selected: false,
      info: [],
      // 新地址选择

      // 埋点
      mdreferrer:'',
      mdreferrer_title:'',
      // qrView:''
      isFirstDay:false,
    };
  },
  components: {
    SetNavBar,
    DescInfo,
  },
  inject: ["reload"],
  beforeCreate() {},
//   beforeRouteEnter(to, from) {
 
//  console.log(to,'这是to1'); //当前

//  console.log(from,'这是from2'); 

// },
beforeRouteEnter(to, from, next) {
    console.log("beforeRouteEnter");
    console.log("thisInBeforeRouteEnter", this);
    next((vm) => {
      console.log("thisInBeforeRouteEnterNext", this);
      console.log("vm", vm);
      console.log("dataDataInBeforeRouteEnter  ", vm.mdreferrer);
      // console.log(vm.getMsg());
      vm.mdreferrer= from.path;
      if(from.name == '' || from.name == null || from.name ==undefined){
        vm.mdreferrer_title = '无上一页'
      }else{
        vm.mdreferrer_title = from.name
      }
      console.log("dataDataInBeforeRouteEnter  ", vm.mdreferrer);
    });
  },
  created() {
    console.log(this.$route,'这是路由')
   

    let hosListStr = localStorage.getItem("HosList");
    if (hosListStr == null) {
      hosList = [];
    } else {
      hosList = JSON.parse(hosListStr);
    }
    localStorage.removeItem("Type1Arr");
    localStorage.removeItem("Type2Arr");
    localStorage.removeItem("Type3Arr");
    this.addressInfoFlag = false;
    localStorage.removeItem("typeId");
    hosId = "";
    count = 5; //设置默认倒计时时间
    // console.log(this.$route.query)
    hosId = this.$route.params.hosId;
    typeId = this.$route.params.typeId;
    if (hosId == null || hosId == "-1") {
      hosId = "";
    } else {
      localStorage.setItem("hosId", hosId);
    }

    const params = {
      wxId: localStorage.getItem("wxId"),
      otherHosId: hosId,
    };
    this.getDefaultHosId(params);
    const paramsadd = {
      id:'',
      level:'1'

    }
    let level = 1
    this.getadd(paramsadd,level)
  },
  mounted(){
    var everypage = JSON.parse(localStorage.getItem('everypage'))
    var yewuxuanze = everypage.yewuxuanze + 1
    everypage.yewuxuanze = yewuxuanze;
    if(yewuxuanze == 1){
     this.isFirstDay = true
    }else{
      this.isFirstDay=false
    }
    localStorage.setItem("everypage", JSON.stringify(everypage));
    
    console.log(this,'这是mounted')
    var mdreferrer_title =  localStorage.getItem('title')
    if(mdreferrer_title == '' ||mdreferrer_title == undefined ||mdreferrer_title ==null){
      // mdreferrer = '没有上一页'
      mdreferrer_title = '没有上一页'
    }
    var title = this.$route.name;
    localStorage.setItem("mdreferrer_title",mdreferrer_title)
    localStorage.setItem("title",title)
    var url = this.$route.path;
    var url_path = this.$route.path;
    var is_first_Day = this.isFirstDay;
    var preview = 'MPViewScreen'
    // var mdreferrer = this.mdreferrer;
    // var mdreferrer_title = this.mdreferrer_title;
    this.$util.BuriedPoint(title,url,url_path,is_first_Day,preview,mdreferrer_title)
  },
  computed: {
    ...mapState(["parentHosId"]),
  },
  methods: {
    // 新地址业务
    choseAdd: function () {
      this.showChose = true;
    },
    closeAdd: function () {
      console.log('关闭选择地址')
      this.showChose = false;
      console.log(this.area,this.showProvince,this.showCity,this.showDistrict)
    },
    // _filter(add, name, code) {
    //   if(name == 'city'){
      
    //   }
    //   let result = [];
    //   for (let i = 0; i < add.length; i++) {
    //     if (code == add[i].id) {
    //       result = add[i][name];
    //     }
    //   }
    //   return result;
    // },
    getProvinceId: function (code, input, index) {
      console.log(code)
      this.province = code;
      this.Province = input;
      this.showProvince = false;
      this.showCity = true;
      this.showDistrict = false;
      // this.showCityList = this._filter(this.info, "city", this.province);
      const paramsadd = {
          id:code,
          level:'3',
      }
      let level =2;
      this.getadd(paramsadd,level)
      // 点击选择当前
      this.info.map((a) => (a.selected = false));
      this.info[index].selected = true;
      console.log(this.info)
      this.provinceName =  this.info[index].name
      province = this.info[index].name
    },
    provinceSelected: function () {
      // 清除市级和区级列表
      this.showCityList = false;
      this.showDistrictList = false;
      // 清除市级和区级选项
      this.City = false;
      this.District = false;
      // 选项页面的切换
      this.showProvince = true;
      this.showCity = false;
      this.showDistrict = false;
    },
    getCityId: function (code, input, index) {
      console.log(code,index)
      this.city = code;
      this.City = input;
      this.showProvince = false;
      this.showCity = false;
      this.showDistrict = true;
      if(this.showCityList[index].children != undefined){
        this.showDistrictList = this.showCityList[index].children
      }else{
          this.showChose = false;
          
      }
      // this.showDistrictList = this._filter(
      //   this.showCityList,
      //   "district",
      //   this.city
      // );
      // 选择当前添加active
      this.showCityList.map((a) => (a.selected = false));
      this.showCityList[index].selected = true;
      this.cityName = this.showCityList[index].name
      if(this.showCityList[index].children == undefined){
        this.area = this.provinceName + '/' +  this.cityName
      }
      city = this.showCityList[index].name
    },
    citySelected: function () {
      this.showProvince = false;
      this.showCity = true;
      this.showDistrict = false;
    },
    getDistrictId: function (code, input, index) {
      this.district = code;
      this.District = input;
      // 选择当前添加active
      this.showDistrictList.map((a) => (a.selected = false));
      this.showDistrictList[index].selected = true;
      this.districtName = this.showDistrictList[index].name
      district = this.showDistrictList[index].name
      this.area = this.provinceName + '/' +this.cityName + '/' + this.districtName
      // 选取市区选项之后关闭弹层
      this.showChose = false;
    },
    districtSelected: function () {
      this.showProvince = false;
      this.showCity = false;
      this.showDistrict = true;
    },

    // 新地址业务

    // 获取行为日志
    // getApplyLog(params){
    //   this.$server.getApplyLog(params).then((res) => {
    //     if(res.result == 1){
    //       console.log('获取log成功____________________________')
    //     }

    //   })
    // },

    getRecommend(params) {
      this.$server.getRecommend(params).then((res) => {
        console.log(res, "9999999999999");
        if (res.result == 1) {
          let limitStatus = res.limitStatus;
          let limitDayStatus = res.limitDayStatus;
          workArray = res.param.channels[0].hbs;

          let hosParams = res.param;
          province = hosParams.province;
          city = hosParams.city;
          district = hosParams.district;
          hosId = hosParams.hosId;

          localStorage.setItem("hosId", hosId);
          if (hosId == 2958) {
            this.isJustShowLogo = true;
          } else {
            this.isJustShowLogo = false;
          }

          this.itemsWork = workArray;
          this.hosParams = hosParams;
          displayOption = workArray[0].hosInfo.displayOption;
          if (displayOption == 99) {
            this.noApply = true;
          } else {
            this.noApply = false;
          }
          console.log(this.displayOption, "ppppppppppppppppppppppppppp");
          // let parentHosId = res.parentHosId;
          if (limitDayStatus == "1") {
            this.$router.replace("/weekendpause");
            return;
          }
          if (limitStatus == "1") {
            //跳转暂停申请界面
            this.$router.replace("/pause");
            return;
          }
          if (hosId == "1023" || hosId == "1024") {
            this.hosNoticeLogo = "";
            this.hospitalPreName = "病案通";
          } else {
            (this.hosNoticeLogo = hosParams.hosLogoUrl),
              (this.hospitalPreName = this.$util.normalString(
                hosParams.hospitalPreName
              ));
            this.hospitalPostName = this.$util.normalString(
              hosParams.hospitalPostName
            );
          }
          let hospitalExpress = res.hospitalExpress;
          if (hospitalExpress != null) {
            this.expressFlag = res.hospitalExpress.expressFlag;
            if (this.expressFlag == "EMS") {
              this.expressDispName = "中国邮政速递";
            } else if (this.expressFlag == "SF") {
              this.expressDispName = "顺丰";
            } else if (this.expressFlag == "ANE") {
              this.expressDispName = "安能";
            } else if (this.expressFlag == "JD") {
              this.expressDispName = "京东物流";
            } else if (this.expressFlag == "ZGYZ") {
              this.expressDispName = "中国邮政";
            } else if (this.expressFlag == "SFDL") {
              this.expressDispName = "顺丰";
            }else if (this.expressFlag == "STO") {
              this.expressDispName = "申通";
            } else if (this.expressFlag == "YD") {
              this.expressDispName = "韵达";
            } else if (this.expressFlag == "ZTO") {
              this.expressDispName = "中通";
            }
          }
          hosItem.hosId = hosId;
          this.initMrInfo();
          this.saveHosList();
          let arrM = hosItem.arrMedical;
          try {
            let length = arrM.length;
            console.log(length);
          } catch (err) {
            arrM = [];
          }

          if (arrM.length > 0) {
            for (let i in arrM) {
              if (arrM[i].userConfirmMode == null || hosItem.hosId != hosId) {
                // arrM = null;
                arrM = [];
                break;
              }
            }
          }
          if (arrM.length == 0) {
            arrMedical = [];
            for (let i in workArray) {
              console.log("lololololo");
              let itemId = workArray[i].id;
              let show = "1";
              let medicalLocal = new Object();
              medicalLocal.id = itemId;
              medicalLocal.show = show;
              if (
                workArray[i].hosInfo != null &&
                workArray[i].hosInfo != undefined
              ) {
                medicalLocal.userConfirmMode =
                  workArray[i].hosInfo.userComfirmMode;
              }
              arrMedical.push(medicalLocal);
            }
          }
          console.log(workArray, "workArray");
          if (workArray.length == 1) {
            console.log("jijijijijiji");
            selectHbsType = workArray[0];
            this.hosExpressDesc = selectHbsType.hosInfo.hosExpressDesc;
            hosSelectExpressId = selectHbsType.hosInfo.hosSelectExpressId;
            this.workId = selectHbsType.id;
            this.expressType = selectHbsType.hBusinessLevelThree;
            this.initPickupParam();
            this.initGetType();
            this.overlayIsShow();
          }
          if (workArray.length > 1) {
            for (let i in workArray) {
              if (workArray[i].default == true) {
                selectHbsType = workArray[i];
                this.hosExpressDesc = selectHbsType.hosInfo.hosExpressDesc;
                hosSelectExpressId = selectHbsType.hosInfo.hosSelectExpressId;
                this.initPickupParam();
                this.expressType = selectHbsType.hBusinessLevelThree;
                this.workId = selectHbsType.id;
                this.initGetType();
                this.overlayIsShow();
              }
            }
          }
          if (hosSelectExpressId > 0) {
            this.showExpressFlag = false;
            if (hosSelectExpressId != 3) {
              this.showExpressList = true;
              const params = {
                hosId: hosId,
                wxId: localStorage.getItem("wxId"),
                currentTime: this.$util.formatTime(new Date()),
              };
              this.getHosExpressList(params);
            }
          } else {
            this.showExpressList = false;
            this.showExpressFlag = true;
          }
          console.log(this.expressType, "选择邮寄还是自提");
          for (let i in this.expressType) {
            if (this.expressType[i].default == true) {
              var selectTypeLog = this.expressType[i].id;
              localStorage.setItem("selectTypeLog", selectTypeLog);
            }
          }
          this.getDefaultAddress();
        }
      });
    },
    /**
     * 选择业务类型
     */
    selectWorkType(item) {
      selectHbsType = item;
      this.selectUseExpressType = {};
      infoFlag = false;
      this.tid = '';
      this.hosExpressDesc = item.hosInfo.hosExpressDesc; //邮寄描述文字
      this.expressType = item.hBusinessLevelThree;
      this.workId = item.id;
      this.initPickupParam();
      this.overlayIsShow();
      this.initGetType();
    },
    /**
     * 选择获取方式
     */
    selectTheWay(item, index) {
      this.tid = item.id;
      console.log(item);
      var selectTypeLog = item.id;
      localStorage.setItem("selectTypeLog", selectTypeLog);
      this.getWayOperate(item.type);
      let printType = item.id;
      let params = {
        hosId: hosId,
        wxId: localStorage.getItem("wxId"),
        printType: printType,
      };
      this.getSelectType(selectHbsType.types, index);
      this.getPickupPlace(params);
    },
    /**
     * 初始化获取方式
     */
    initGetType() {
      // if (this.expressType.length == 1) {
      //   selectExpressType = this.expressType[0];
      //   infoFlag = true;
      //   this.tid = this.expressType[0].id;
      //   this.getWayOperate(selectExpressType.type);
      //   this.getSelectType(selectHbsType.types, 0);
      // }
      if (this.expressType.length >= 1) {
        for (let i in this.expressType) {
          if (this.expressType[i].default == true) {
            selectExpressType = this.expressType[i];
            infoFlag = true;
            this.tid = this.expressType[i].id;
            this.getWayOperate(selectExpressType.type);
            this.getSelectType(selectHbsType.types, i);
            break;
          }
        }
      }
      if (
        selectExpressType == undefined ||
        selectExpressType == null ||
        selectExpressType == "" ||
        infoFlag == false
      ) {
        this.showDescPickUp = false;
        this.showDescExpress = false;
        this.showBrowseTips = false;
        this.showAddressInfo = false;
        return;
      }
    },
    getWayOperate(type) {
      switch (type) {
        case "HB_TYPE_SHIPPING_APPOINT_PICKUP":
          //自提
          if (pickupOut == 1) {
            this.showDescPickUp = true;
            this.showDescExpress = false;
            this.showBrowseTips = false;
            this.showAddressInfo = true;
            this.addressInfoFlag = true;
          } else {
            this.showDescPickUp = true;
            this.showDescExpress = false;
            this.showBrowseTips = false;
            this.showAddressInfo = false;
            this.addressInfoFlag = false;
          }

          break;
        case "HB_TYPE_SHIPPING_EXPRESS":
          // 疫情邮寄提示
          Dialog.confirm({
            title: "提示",
            message:
              "个人信息用途提示：当您选择邮寄业务时，我们会收集您收件人姓名、联系电话、详细收件地址信息，如您选择拒绝提供，您无法使用邮寄业务。",
            confirmButtonText: "同意",
            cancelButtonText: "不同意",
          })
            .then(() => {
              // on confirm
            })
            .catch(() => {
              setTimeout(function () {
                document.addEventListener(
                  "WeixinJSBridgeReady",
                  function () {
                    this.WeixinJSBridge.call("closeWindow"); //安卓手机关闭代码
                  },
                  false
                );
                this.WeixinJSBridge.call("closeWindow"); //苹果手机关闭代码
              }, 50);
              // do something
              console.log("dianji1");
              this.modalHidden = true;
              console.log("dianji2");
              window.opener = null;
              console.log("dianji3");
              window.open("about:blank", "_top").close();
              console.log("dianji4");
              // on cancel
            });
          // 邮寄
          this.showDescPickUp = false;
          this.showDescExpress = true;
          this.showBrowseTips = false;
          this.showAddressInfo = true;
          this.addressInfoFlag = true;
          break;
        case "HB_TYPE_WMP_MR_BROWSE":
          // 门诊
          this.showDescPickUp = false;
          this.showDescExpress = false;
          this.showBrowseTips = true;
          this.showAddressInfo = false;
          this.addressInfoFlag = false;
          break;
        default:
          break;
      }
    },
    /**
     * 初始化自提选项的显示内容
     */
    initPickupParam() {
      hosDispWaitTime = selectHbsType.hosInfo.hosDispWaitTime;
      pickUpDesc = selectHbsType.hosInfo.pickUpDesc;
      pickupOut = selectHbsType.hosInfo.pickupOut;
      if (
        hosDispWaitTime != undefined &&
        hosDispWaitTime != null &&
        hosDispWaitTime != ""
      ) {
        count = hosDispWaitTime;
      }
      if (pickUpDesc == undefined || pickUpDesc == null || pickUpDesc == "") {
        pickUpDesc =
          "病历复印完成后，我们将给您下发自提通知。请您收到自提通知后，凭自提码到自提地点领取病历。（请在工作时间内前往领取地点）。";
      }
      this.pickupTips = pickUpDesc;
      // that.setData({
      //   pickupTips: pickUpDesc,
      //   browseTip: '暂无'
      // })
    },
    /**
     * 获取快递公司列表
     */
    getHosExpressList(params) {
      let that = this;
      this.$server.getHosExpressList(params).then((res) => {
        if (res.result == 1) {
          that.expressItems = res.hosExpressList;

          if (that.expressItems.length > 0) {
            if (that.expressItems.length == 1) {
              that.radio2 = 0;
              expressId = that.expressItems[0].expressId;
              return;
            }
            for (let i in that.expressItems) {
              if (that.expressItems[i].isDefault == 1) {
                that.radio2 = parseInt(i);
                expressId = that.expressItems[i].expressId;
              }
            }
          }
        }
      });
    },
    selectExpress(e) {

      expressId = e.expressId;
      console.log(expressId);
    },
    /**
     * 显示地址选择器
     */
    showPopAddress() {
      // this.initAddressPicker();
      this.showChose = true;
      this.showProvince = true;
      this.showCity = false;
      this.showDistrict = false
      this.info = [];
      this.Province = false;
      this.City = false;
      this.District = false;
      const paramsadd = {
      id:'',
      level:'1',
    }
    let level = 1
    this.getadd(paramsadd,level)
      // this.getadd(params,level)
      // console.log(provinceCode);
      // console.log(cityCode);
      // console.log(districtCode);
      // let defaultValue;
      // if (provinceCode == null) {
      //   defaultValue = ["110000", "110000", "110101"];
      // } else {
      //   defaultValue = [provinceCode, cityCode, districtCode];
      // }
      // let that = this;
      // // this.show = true;
      // this.$weui.picker(cityList.areaList, {
      //   className: "custom-classname",
      //   container: "body",
      //   depth: 3,
      //   defaultValue: defaultValue,
      //   onChange: function (result) {
      //     console.log(result);
      //   },
      //   onConfirm: function (result) {
      //     console.log(result[0].label);
      //     let county = result[2] ? "/" + result[2].label : "";
      //     that.area = result[0].label + "/" + result[1].label + county;
      //   },
      //   id: "addressPicker" + defaultValue[1],
      // });
    },
    /**
     * 地址选择器确定按钮点击
     */
    confirm(e) {
      console.log(e);
      this.area = e[0].name + "/" + e[1].name + "/" + e[2].name;
      this.show = false;
    },
    /**
     * 地址选择器取消按钮点击
     */
    cancel() {
      this.show = false;
    },
    /**
     * 获取预约自提地址
     */
    getPickupPlace(params) {
      this.$server.getPickupPlace(params).then((res) => {
        if (res.result == 1) {
          let hbPickPlaces = res.hbPickPlaces;
          if (hbPickPlaces != null) {
            this.hbPickPlaces = hbPickPlaces;
            this.showPickupRadio = true;
            selfPickupPlace = hbPickPlaces[0].id;
          } else {
            this.showPickupRadio = false;
          }
        }
      });
    },
    /**
     * 显示公告
     */
    showNoticeClick(e) {
      console.log(e);
      this.showStyle = true;
      this.showOverlay = true;
      if (mode == "2" || mode == "4") {
        this.countDown(count, mode);
      } else if (mode == "3") {
        this.countDownBtn(count);
      }
    },
    // 封装地址请求
    // let addurl = 'https://gateway.vmeeting.cn/common-admin/common/dict/region/tree'
    addGet(addurl,params = {}){
    return new Promise((resolve, reject) => {
        axios.get(addurl,{
            params:params
        })
        .then(response => {
            resolve(response.data);
        })
        .catch(err => {
            console.log('get请求方法当中出现问题')
            reject(err)
        })
    })
},
getadd(params,level){
  console.log('调用地址函数',level)
    let addurl = 'https://gateway.vmeeting.cn/common-admin/common/dict/region/tree?';
    this.addGet(addurl,params).then ((res) =>{
      console.log('点用地址函数11111')
      console.log(res)
      if(res.success == true){
        if(level == 1){
          console.log('这是level为1的时候')
          this.info = res.data
        }
        if(level == 2){
          // this.info = res.data
          console.log(res.data.children)
          if(res.data.children == undefined){
            this.showCityList = res.data[0].children
          }
        }
        if(level == 3){
          console.log(res.data.children)
        }
        console.log('调用地址成功')
       
      }
    })
},
    getHosLob(params) {
      this.$server.getHosLob(params).then((res) => {
        console.log(res, "000000000000000000000000000");
        if (res.result == 1) {
          let hpe = res.hpe;
          let imHpe = res.imHpe;
          if (hpe != null && hpe != undefined) {
            this.html = hpe.paramValue;
          }
          if (imHpe != null && imHpe != undefined) {
            this.imHtml = imHpe.paramValue;
          }
          if (hosConfig != null) {
            mode = hosConfig.userComfirmMode;
            console.log(mode, "++++++++++++++++++++++++++++++++");
            // mode = 3;
            switch (mode) {
              case 1:
                //显示确定按钮以及checkbox
                this.isShowClose = false;
                this.isShowTimer = false;
                this.isShowAgree = true;
                this.isShowConfirm = true;
                this.isCheckDisabled = false;
                break;
              case 3:
                this.isShowClose = false;
                this.isShowTimer = false;
                this.isShowAgree = true;
                this.isShowConfirm = true;
                this.isCheckDisabled = true;
                //显示确定按钮
                break;
              case 2:
              case 4:
                //显示倒计时
                this.isShowClose = false;
                this.isShowTimer = true;
                this.isShowAgree = false;
                this.isShowConfirm = false;
                // this.countDown(4,mode)
                break;
              default:
                //显示关闭按钮
                this.isShowClose = true;
                this.isShowTimer = false;
                this.isShowAgree = false;
                this.isShowConfirm = false;
                break;
            }
            switch (hosConfig.displayOption) {
              case 1:
                this.judgeIfShowOverlay();
                break;
              case 2:
                //每次进入都弹出公告浮层
                this.showOverlay = true;
                if (mode == "2" || mode == "4") {
                  this.countDown(count, mode);
                }
                if (mode == "3") {
                  this.countDownBtn(count);
                }
                break;
              default:
                break;
            }
          }
          if (this.checked == false) {
            this.isDisabled = true;
          } else {
            this.isDisabled = false;
          }
        }
      });
    },
    /**
     * 获取默认地址
     */
    getDefaultAddress() {
      this.$server.getDefaultAddr().then((res) => {
        if (res.result == 1) {
          defaultAddress = res.address;
        }
        if (defaultAddress != null) {
          this.name = defaultAddress.receiverName;
          this.phoneNum = defaultAddress.receiverTel;
          this.message = defaultAddress.receiverAddr;
          this.provinceName = defaultAddress.receiverProvince;
          this.cityName = defaultAddress.receiverCity;
          this.districtName = defaultAddress.receiverDistrict
          this.area =
            defaultAddress.receiverProvince +
            "/" +
            defaultAddress.receiverCity +
            "/" +
            defaultAddress.receiverDistrict;
        } else {
          this.initAddressPicker();
        }
      });
    },
    initAddressPicker() {
      for (let i in cityList.areaList) {
        let provinceLabel = cityList.areaList[i].label;
        if (provinceLabel == province) {
          let citys = cityList.areaList[i].children;
          provinceCode = cityList.areaList[i].value;
          for (let j in citys) {
            let cityLabel = citys[j].label;
            if (city == cityLabel) {
              let districts = citys[j].children;
              cityCode = citys[j].value;
              for (let k in districts) {
                let districtLabel = districts[k].label;
                if (district == districtLabel) {
                  districtCode = districts[k].value;
                }
              }
            }
          }
        }
      }
      console.log(provinceCode);
      console.log(cityCode);
      console.log(districtCode);
    },
    closePopDialog() {
      this.showOverlay = false;
    },
    overlayIsShow() {
      // clearTimeout(timer2);
      hosConfig = selectHbsType.hosInfo;
      let params = {
        wxId: localStorage.getItem("wxId"),
        hosId: hosId,
        bType: selectHbsType.type,
      };
      this.getHosLob(params);
    },
    checkboxChange(e) {
      if (e == false) {
        this.isDisabled = true;
      } else {
        this.isDisabled = false;
      }
    },
    confirmNotice() {
      this.showOverlay = false;
    },
    //倒计时关闭公告
    countDown(count, mode) {
      let that = this;
      let timerNum = 0; //eslint-disable-line no-unused-vars
      if (count == 0) {
        clearTimeout(timer);
        if (mode == "4") {
          this.isShowTimer = true;
          this.timerNum = "关闭";
          this.showOverlay = true;
          this.isTimerDisabled = false;
        } else {
          this.showOverlay = false;
          this.isShowTimer = true;
        }
        return;
      } else {
        this.isShowTimer = true;
        if (mode == "4") {
          timerNum = count + "s";
          this.isTimerDisabled = true;
        } else {
          timerNum = count + "跳过";
          this.isTimerDisabled = false;
        }
        count--;
        this.timerNum = timerNum;
      }

      timer = setTimeout(function () {
        that.countDown(count, mode);
      }, 1000);
    },
    //倒计时确认按钮可以点击
    countDownBtn(count) {
      let that = this;
      let timerNum = 0; //eslint-disable-line no-unused-vars
      if (count == 0) {
        clearTimeout(timer2);
        this.confirmText = "确定";
        this.isDisabled = false;
        this.isCheckDisabled = false;
        return;
      } else {
        timerNum = count + "s";
        count--;
        this.confirmText = timerNum;
        this.isDisabled = true;
      }

      timer2 = setTimeout(function () {
        that.countDownBtn(count);
      }, 1000);
    },
    closeTimer() {
      this.showOverlay = false;
      clearTimeout(timer);
    },
    judgeIfShowOverlay() {
      if (hosItem.arrMedical == null || hosItem.arrMedical.length == 0) {
        for (let i in workArray) {
          if (selectHbsType == workArray[i]) {
            if (arrMedical[i].show == "0") {
              this.showOverlay = false;
            } else {
              this.showOverlay = true;
              if (mode == "2" || mode == "4") {
                this.countDown(count, mode);
              }
              if (mode == "3") {
                this.countDownBtn(count);
              }
            }
            let objNotice = new Object();
            objNotice.id = workArray[i].id;
            objNotice.show = "0";
            objNotice.userConfirmMode = workArray[i].hosInfo.userComfirmMode;
            arrMedical.splice(i, 1, objNotice);
          }
        }
      } else {
        arrMedical = hosItem.arrMedical;
        for (let i in arrMedical) {
          if (arrMedical[i].id == selectHbsType.id) {
            if (arrMedical[i].show == "0") {
              this.showOverlay = false;
            } else {
              this.showOverlay = true;
              if (mode == "2" || mode == "4") {
                this.countDown(count, mode);
              }
              if (mode == "3") {
                this.countDownBtn(count);
              }
            }
            let objNotice = new Object();
            objNotice.id = workArray[i].id;
            objNotice.show = "0"; //0表示公告已经弹出过，不再弹
            objNotice.userConfirmMode = workArray[i].hosInfo.userComfirmMode;
            arrMedical.splice(i, 1, objNotice);
            // mode = selectHbsType.userComfirmMode;
          }
        }
      }
      hosItem.arrMedical = arrMedical;
    },
    initMrInfo() {
      if (hosList != null && hosList != undefined && hosList.length > 0) {
        for (let item in hosList) {
          if (hosId != null && hosId == hosList[item].hosId) {
            hosItem = hosList[item];
            console.log(hosItem);
            break;
          }
        }
      }
    },
    /**
     * 切换服务
     */
    switchService() {
      this.initMrInfo();
      hosItem.hosId = hosId;
      hosItem.arrMedical = arrMedical;
      this.saveHosList();
      // this.$router.push({
      // 	path: '/service',
      // 	query: {
      // 		hosId: hosId
      // 	}
      // });
      // this.$router.push('/service/' + hosId + '/' + parentHosId);
      this.isShowPage = false;
      this.isShowDistrict = false;
      this.isShowService = true;
    },
    /**
     * 选择医院
     */
    choosHospital() {
      this.initMrInfo();
      hosItem.hosId = hosId;
      hosItem.arrMedical = arrMedical;
      this.saveHosList();
    },
    /**
     * 获取typeId
     */
    // getTypeId() {
    // 	let items = this.$store.getters.items;
    // 	if (items == null || items.length == 1) {
    // 		this.isShowServiceBtn = false;
    // 	} else if (items.length > 1) {
    // 		this.isShowServiceBtn = true;
    // 	}
    // },
    getDefaultHosId(params) {
      this.$server.getDefaultHosId(params).then((res) => {
        if (res.result == 1) {
          parentHosId = res.parentHosId;
          hosId = res.hosId;
          guideBId = res.guideBId;
          if (res.hosId == null) {
            this.$router.replace("/hos-list");
          } else {
            if (parentHosId == null || parentHosId <= 0) {
              this.isShowDistrictBtn = false;
            } else {
              this.isShowDistrictBtn = true;
            }
            let obj = {
              hosId: hosId,
              wxId: params.wxId,
            };
            this.getHosDistrict(obj);
          }
        } else if (res.result == 200) {
          // this.reload();
        }
      });
    },
    getHbMrRecordType(params) {
      this.$server.getHbMrRecordType(params).then((res) => {
        if (res.result == 1) {
          let hmrts = res.hmrts;
          this.he = res.he;
          if (hmrts == null || hmrts.length == 0) {
            this.$router.replace("/hos-list");
            return;
          }
          if (hmrts.length == 1) {
            this.typeId = hmrts[0].code;
            this.isShowServiceBtn = false;
            this.isShowService = false;
            this.isShowDistrict = false;
            this.isShowPage = true;
            if(guideBId == undefined){
              guideBId =''
            }
            let obj = {
              wxId: localStorage.getItem("wxId"),
              hosId: hosId,
              typeId: this.typeId,
              bId : guideBId
            };
            this.getRecommend(obj);
          }
          if (hmrts.length > 1) {
            let hmrtsList = new Array();
            for (let i in hmrts) {
              let obj = new Object();
              obj.code = hmrts[i].code;
              obj.desc = hmrts[i].desc;
              if (hmrts[i].code == 1) {
                obj.className = "mr_item1";
              } else if (hmrts[i].code == 2) {
                obj.className = "mr_item2";
              } else if (hmrts[i].code == 3) {
                obj.className = "mr_item3";
              }
              hmrtsList.push(obj);
            }
            this.hmrtsList = hmrtsList;
            this.isShowPage = false;
            this.isShowService = true;
            this.isShowDistrict = false;
            this.isShowServiceBtn = true;
          }
        }
      });
    },
    /**
     * 自提点选择
     */
    pickRaido(item) {
      selfPickupPlace = item.id;
    },
    /**
     * 显示错误提示
     */
    showErrorMsg() {
      Notify({
        type: "warning",
        message: "请输入正确的手机号码",
      });
    },
    watchNum() {
      let regPhoneNo = "^1[0-9]{10}$";
      this.isRegValid(this.phoneNum, regPhoneNo);
    },
    isRegValid(inputValue, tmpRole) {
      var regName = new RegExp(tmpRole);
      console.log(regName);
      console.log(regName.test(inputValue));
      // console.log(regName.exec(inputValue))
      if (regName.test(inputValue)) {
        // this.${alertName} = true;
        this.isShowPhoneAlert = false;
      } else {
        this.isShowPhoneAlert = true;
      }
    },
    /**
     * 下一步
     */
    next() {
      console.log("next1");
      if (Object.keys(this.selectUseExpressType).length == 0) {
        Notify({
          type: "warning",
          message: "请选择类型和获取方式",
        });
        return;
      }
      console.log("next2", this.addressInfoFlag);
      if (this.addressInfoFlag) {
        this.infoVerify();
      } else {
        hosItem.selectHbsType = selectHbsType;
        hosItem.selectExpressType = selectExpressType;
        hosItem.selectUseExpressType = this.selectUseExpressType;
        hosItem.hosId = hosId;
        hosItem.arrMedical = arrMedical;
        hosItem.code = this.typeId;
        hosItem.receiverName = this.name;
        hosItem.receiverTel = this.phoneNum;
        hosItem.receiverAddress = this.message;
        // hosItem.receiverProvince = this.provinceName;
        // hosItem.receiverCity = this.cityName;
        // if(this.districtName == ''){
        //   hosItem.receiverDistrict = this.districtName;
        // }
        // hosItem.isPrintInvoice = this.selectUseExpressType.invoice.choice;
        hosItem.expressId = "";
        // console.log(localStorage.getItem('HosList'))
        // console.log(localStorage.getItem('HosItem'))
        localStorage.setItem("hosId", hosItem.hosId);
        localStorage.setItem("HosItem", JSON.stringify(hosItem));
        // console.log(localStorage.getItem('HosList'))
        // console.log(localStorage.getItem('HosItem'))
        console.log(localStorage.getItem("hosId"));
        this.$router.push("/upload");
      }
      let logparams = {
        userId: localStorage.getItem("userId"),
        phoneV: localStorage.getItem("os"),
        wxV: localStorage.getItem("version"),
        wxId: localStorage.getItem("wxId"),
        pId: 1,
        type: localStorage.getItem("selectTypeLog"),

        // hosId: hosId,
        // bType: selectHbsType.type,
      };
      console.log("next3", logparams);
      // this.getApplyLog(logparams)
    },
    infoVerify() {
      if (hosSelectExpressId > 0 && hosSelectExpressId != 3) {
        if (this.$util.isNullString(expressId)) {
          Notify({
            type: "warning",
            message: "请选择快递公司",
          });
          return;
        }
      }
      if (this.name.length > 20) {
        Notify({
          type: "warning",
          message: "输入的收件人姓名超出20位",
        });
        return;
      }
      if (this.$util.isNullString(this.name)) {
        Notify({
          type: "warning",
          message: "请输入收件人姓名",
        });
        return;
      }
      if (
        this.$util.isNullString(this.phoneNum) ||
        this.isShowPhoneAlert == true
      ) {
        Notify({
          type: "warning",
          message: "请输入正确的手机号码",
        });
        return;
      }
      if (this.area == "") {
        Notify({
          type: "warning",
          message: "请选择所在地区",
        });
        return;
      }
      if (this.$util.isNullString(this.message)) {
        Notify({
          type: "warning",
          message: "请滑至底部输入详细地址",
        });
        return;
      }
      if (this.$util.checkSpecial(this.message)) {
        Notify({
          type: "warning",
          message: "详细地址不能含有特殊字符",
        });
        return;
      }
      this.saveData();
    },
    getSelectType(arr, index) {
      for (let i in arr) {
        if (arr[i].bId == this.expressType[index].id) {
          this.selectUseExpressType = arr[i];
        }
      }
    },
    saveData() {
      this.initMrInfo();
      this.setArrValue();
      this.$router.push("/upload");
    },
    setArrValue() {
      let arr;
      console.log(this.area)
      if (this.area.length > 0) {
        arr = this.area.split("/");
        console.log(arr);
      }

      hosItem.expressId = expressId;
      hosItem.selectHbsType = selectHbsType;
      hosItem.selectExpressType = selectExpressType;
      hosItem.selectUseExpressType = this.selectUseExpressType;
      hosItem.receiverProvince = arr[0];
      hosItem.receiverCity = arr[1];
      hosItem.selfPickupPlace = selfPickupPlace;
      if (arr[2] == undefined) {
        hosItem.receiverDistrict = "";
      } else {
        hosItem.receiverDistrict = arr[2];
      }

      hosItem.hosId = hosId;
      hosItem.arrMedical = arrMedical;
      hosItem.code = this.typeId;
      hosItem.receiverName = this.name;
      hosItem.receiverTel = this.phoneNum;
      hosItem.receiverAddress = this.message;
      // hosItem.isPrintInvoice = this.selectUseExpressType.invoice.choice;
      localStorage.setItem("HosItem", JSON.stringify(hosItem));
      console.log(hosItem);
      if (this.isIncludeItem()) {
        for (let item in hosList) {
          let objArr = hosList[item];
          let hosId = objArr.hosId;
          if (hosItem.hosId == hosId) {
            hosList.splice(item, 1, hosItem);
            break;
          }
        }
      } else {
        console.log(hosList);
        hosList = hosList.concat(hosItem);
      }

      // localStorage.setItem('HosList', hosList);
    },
    isIncludeItem() {
      for (let item in hosList) {
        let objArr = hosList[item];
        let hosId = objArr.hosId;
        if (hosItem.hosId == hosId) {
          return true;
        }
      }
      return false;
    },
    saveHosList() {
      localStorage.setItem("HosItem", JSON.stringify(hosItem));
      if (this.isIncludeItem()) {
        for (let item in hosList) {
          let objArr = hosList[item];
          let hosId = objArr.hosId;
          if (hosItem.hosId == hosId) {
            hosList.splice(item, 1, hosItem);
            break;
          }
        }
      } else {
        console.log(hosList);
        hosList = hosList.concat(hosItem);
      }
      localStorage.setItem("HosList", JSON.stringify(hosList));
      // hosItem = new Object();
    },
    /**
     * 选择服务
     */
    selectService(e) {
      let code = e;
      console.log(code);
      // this.$router.push({ path: '/apply', query: { typeId: code ,hosId:hosId}})
      // this.$router.push('/apply/' + hosId + '/' + code)
      this.isShowPage = true;
      this.isShowService = false;
      this.isShowDistrict = false;
      this.typeId = code;
      if( guideBId == undefined){
        guideBId = ''
      }
      let params = {
        wxId: localStorage.getItem("wxId"),
        hosId: hosId,
        typeId: this.typeId,
        bId : guideBId
      };
      this.getRecommend(params);
    },
    /**
     * 切换分区
     */
    switchDistrict() {
      hosItem.hosId = hosId;
      hosItem.arrMedical = arrMedical;
      this.saveHosList();
      this.isShowDistrict = true;
      this.isShowPage = false;
      this.isShowService = false;
      const params = {
        wxId: localStorage.getItem("wxId"),
        hosId: parentHosId,
      };
      this.getHosDistrict(params);
    },
    /**
     * 选择分区医院item
     */
    selectHos(e) {
      const params = {
        wxId: localStorage.getItem("wxId"),
        otherHosId: e,
      };
      this.getDefaultHosId(params);
    },

    /**
     * 获取分区数据
     */
    getHosDistrict(params) {
      this.$server.getHosDistrict(params).then((res) => {
        if (res.result == 1) {
          let heList = res.heList;
          if (heList == null) {
            if (typeId == "-1") {
              this.getHbMrRecordType(params);
              return;
            }
            this.isShowDistrict = true;
            this.isShowPage = false;
          } else {
            let heListArr = new Array();
            // for (let i in heList) {
            for (let i = 0; i < heList.length; i++) {
              let obj = new Object();
              obj.hosId = heList[i].hosId;
              obj.hosLogoUrl = heList[i].hosLogoUrl;
              obj.hosName =
                this.$util.normalString(heList[i].hospitalPreName) +
                this.$util.normalString(heList[i].hospitalPostName);
              obj.hBusinessLevelTwo = heList[i].hBusinessLevelTwo;
              obj.hBusinessLevelThree = heList[i].hBusinessLevelThree;
              obj.name = heList[i].name;
              obj.hosAddr = heList[i].hosAddr;
              heListArr.push(obj);
            }
            this.itemsDis = heListArr;
            this.hospitalParam = res.hospitalParam;
            this.isShowDistrict = true;
            this.isShowPage = false;
            this.hosName =
              this.$util.normalString(res.hospitalParam.hospitalPreName) +
              this.$util.normalString(res.hospitalParam.hospitalPostName);
          }
        }
      });
    },
  },
};
</script>

<style lang="less">
.forbidden_scroll {
  position: fixed;
  height: 100%;
}

.content-page {
  margin-top: 80px;
}

.apply-title-center {
  background-color: white;
  border-bottom: 1px solid #ddd;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
  flex-direction: row;
  -webkit-flex-direction: row;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  height: fit-content;
}

.hos-cell {
  background-color: white;
  margin: 10px;
  height: 95px;
  border-radius: 5px;
}

.title_left {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
  margin-left: 10px;
}

.title_right {
  /* display: flex; */
  /* display: -webkit-flex; */
  display: inline-block;
  align-items: center;
  -webkit-align-items: center;
  font-size: 12px;
  white-space: nowrap;
}

.title {
  font-size: 14px;
  /* margin-left: 10px; */
  line-height: 1.4;
}

.hos-logo {
  margin: 10px 10px;
  /*margin-left: 20px;*/
  /*margin-top: 5px;*/
  /*margin-bottom: 5px;*/
  width: 1.48rem;
  height: 1.48rem;
  float: left;
}

.select_hos {
  color: #1aac19;
  font-size: 15px;
  font-weight: bold;
}

.multi-hos_tips {
  background: #effbff;
  display: flex;
  display: -webkit-flex;
  /* Safari */
  padding: 10px;
}

.multi-hos_tips_content {
  color: #333;
  font-size: 15px;
}

.btn-print {
  position: relative;
  width: 92px;
  height: 25px;
  text-align: center;
  border: 1px solid #999;
  border-radius: 3px;
  color: #999;
  background: #fff;
  padding: 5px;
  margin: 5px;
}

.btn-print .select-icon {
  display: none;
}

.btn-print-select {
  position: relative;
  width: 92px;
  height: 25px;
  text-align: center;
  padding: 5px;
  border: 1px solid #f3781f;
  border-radius: 3px;
  color: #f16c1d;
  background: #fff8f2;
  margin: 5px;
}

.select-icon {
  position: absolute;
  right: 0px;
  bottom: 0px;
  width: 15px;
  height: 15px;
}

.radio-content {
  text-align: center;
  flex-wrap: wrap;
}

.line {
  background-color: #eeeeee;
  width: auto;
  height: 1px;
}

.line-left {
  background-color: #ebedf0;
  width: auto;
  height: 1px;
  margin-left: 16px;
}

.express-img {
  width: 40px;
  height: auto;
  margin-left: 2px;
}

.express-logo {
  width: 60px;
  height: auto;
  margin-right: 15px;
  align-self: center;
}

.express-radio {
  width: 225px;
  display: flex;
  flex-wrap: wrap;
}

.express-title {
  width: 90px;
}

.radio-item {
  margin: 10px 0;
}

.radio {
  display: flex;
  width: 50%;
}

.radio-group {
  display: flex;
  flex-wrap: wrap;
}

.van-radio-group {
  display: flex;
}

.weui-cell {
  background: #fff;
}

.van-radio {
  padding: 5px 0;
}

.van-icon-info-o {
  color: #ff0000;
}

.raido-group-pickup {
  display: flex;
  flex-direction: column;
}

.radio-pickup {
  background: #fff;
  padding: 15px;
  position: relative;
}

.radio-pickup:not(:last-child)::after {
  position: absolute;
  box-sizing: border-box;
  content: " ";
  pointer-events: none;
  right: 0;
  bottom: 0;
  left: 16px;
  border-bottom: 1px solid #ebedf0;
  -webkit-transform: scaleY(0.5);
  transform: scaleY(0.5);
}

.pick_name {
  font-weight: bold;
  font-size: 15px;
  color: #333;
}

.pick_address {
  font-size: 14px;
  color: #333;
}

.location_img {
  width: 14px;
  height: 14px;
}

.btn-next {
  position: fixed;
  bottom: 0;
  width: 100%;
  z-index: 2;
}

.bottom-view {
  margin-bottom: 80px;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
  background-color: rgba(0, 0, 0, 0.7);
}

.floatDiv {
  width: calc(100% - 15px * 2);
  height: calc(100% - 110px - 20px);
  background-color: white;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  border-radius: 5px;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}

.close-float {
  position: fixed;
  display: block;
  float: right;
  width: 20px;
  height: 20px;
  /* margin: 10px; */
  right: 15px;
  padding: 10px;
  z-index: 2;
}

.closeTimer {
  position: fixed;
  /*display: block;*/
  display: flex;
  /*Flex布局*/
  display: -webkit-flex;
  /* Safari */
  align-items: center;
  /*指定垂直居中*/
  text-align: center;
  float: right;
  width: 50px;
  height: 20px;
  margin: 10px;
  right: 15px;
  border-radius: 10px;
  background-color: #ccc;
}

.notice {
  width: 100%;
  height: calc(100% - 35px);
  background-color: white;
  position: absolute;
  top: 35px;
  left: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  /*margin-top: 80px;*/
  border-radius: 5px;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}

.notice-titles {
  display: flex;
  display: -webkit-flex;
  text-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  padding-bottom: 5px;
}

.hos-logo2 {
  width: 1.8rem;
  height: 1.8rem;
  margin-right: 10px;
  margin-left: 10px;
  padding-top: 5px;
  align-self: center;
}

.notice-title {
  font-weight: bold;
  padding-top: 5px;
}

.notice-title2 {
  /*margin-top: 2px;*/
  size: 12px;
  color: grey;
}

/**
	 * 公告class
	 */
.wyf-loadmore {
  /*width: 0%;*/
  margin: 15px;
  padding-bottom: 20px;
  line-height: 1.6em;
  font-size: 14px;
  text-align: left;
}

.wyf-li-read {
  list-style: none;
  margin-left: 10px;
  margin-right: 10px;
  padding: 0;
}

.wyf-li-read li {
  display: block;
  padding-left: 1.5em;
  text-indent: -0.7em;
  margin-bottom: 8px;
}

// .wyf-li-read li::before {
// 	content: "• ";
// 	color: green;
// 	/* or whatever color you prefer */
// }

.right {
  float: right;
}

.center {
  text-align: center;
}

.contentview {
  text-align: center;
}

::-webkit-scrollbar {
  display: none;
}

.leftDiv {
  margin-left: 30px;
  float: left;
}

.btn_confirm {
  margin-left: auto;
  margin-right: auto;
  font-size: 16px;
  padding-left: 14px;
  padding-right: 14px;
  width: 90%;
  margin-top: 20px;
  margin-bottom: 20px;
  border-radius: 5px;
}

.check-agree {
  margin-left: 15px;
}

.timerContent {
  font-size: 12px;
  color: #fff;
  word-spacing: 8px;
  letter-spacing: 1px;
  text-align: center;
  margin: 0 auto;
}

button {
  border: 0px;
  background-color: transparent;
}

.notice-title {
  font-weight: bold;
  padding-top: 5px;
  display: flex;
  flex-direction: column;
}

.notice-title-hosName {
  align-self: center;
  margin: auto 0;
}

.notice-title-two {
  font-weight: bold;
  padding-top: 5px;
}

.hosLogo {
  width: 200px;
  padding: 5px 0;
  height: auto;
}

.hosLogo2 {
  width: 225px;
  padding: 5px 0;
  height: 100%;
}

/* 多院区列表布局 */

.multi-hos {
  margin-bottom: 10px;
}

.multi-hospital-cell {
  display: flex;
  display: -webkit-flex;
  /* Safari */
  background: #fff;
  position: relative;
}

.multi-hospital-cell::after {
  content: " ";
  position: absolute;
  left: 15px;
  bottom: 0;
  right: 15px;
  height: 1px;
  border-bottom: 1px solid #d9d9d9;
  color: #d9d9d9;
}

.logo_cell {
  margin: auto 0;
}

.logo_content {
  position: relative;
  width: 2.48rem;
  height: 2.48rem;
  margin: 20px;
  display: inline-block;
  align-self: center;
}

.multi-hos_content {
  display: flex;
  display: -webkit-flex;
  /* Safari */
  flex-direction: column;
  padding: 10px 0;
}

.multi-hos_title {
  font-size: 16px;
  color: #333;
  font-weight: bold;
}

.hos_item_type {
  display: flex;
  display: -webkit-flex;
  /* Safari */
  margin-top: 5px;
  margin-left: -5px;
  flex-wrap: wrap;
}

.multi-hos_address {
  display: flex;
  margin-top: 5px;
}

.hos_item_address {
  font-size: 15px;
}

.address_logo {
  display: inline-block;
  align-self: center;
  width: 15px;
  height: 15px;
}

.hos_zhushi {
  font-size: 14px;
  color: #999;
}

.zhushi {
  padding: 10px 15px;
  font-size: 14px;
  color: #999;
  background: #fff;
}

.multi-hos_tips {
  background: #effbff;
  display: flex;
  display: -webkit-flex;
  /* Safari */
  padding: 10px;
}

.multi-hos_tips_content {
  color: #333;
  font-size: 15px;
}

.select_hos {
  color: #1aac19;
  font-size: 15px;
  font-weight: bold;
}

.multi-hospital {
  margin-bottom: 20px;
  background: #efeff4;
  position: relative;
  z-index: 4;
}

.multi-hos_logo {
  width: 2.48rem;
  height: 2.48rem;
  margin: 5px;
}

.multi-hos_title {
  font-size: 16px;
  font-weight: bold;
}

.navigator-hover {
  background-color: #e5e5e5;
}

.hos_warn {
  color: red;
  font-size: 15px;
  margin: auto;
}

.apply-title-center2 {
  background-color: white;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
  flex-direction: row;
  -webkit-flex-direction: row;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  /* height: 50px; */
  position: relative;
}

.apply-title-center2::after {
  content: " ";
  position: absolute;
  left: 15px;
  bottom: 0;
  right: 15px;
  height: 1px;
  border-bottom: 1px solid #d9d9d9;
  color: #d9d9d9;
}

.ann {
  font-size: 12px;
  text-align: center;
  color: #1aac19;
  padding-left: 2px;
  padding-right: 2px;
  border: 1px solid #1aac19;
  white-space: nowrap;
  margin-right: 10px;
}

.selHos {
  color: #1aac19;
  padding-left: 5px;
  padding-right: 5px;
  margin-right: 10px;
}

.selHos::after {
  content: " ";
  display: inline-block;
  height: 6px;
  width: 6px;
  border-width: 2px 2px 0 0;
  border-color: #1aac19;
  border-style: solid;
  -webkit-transform: matrix(0.71, 0.71, -0.71, 0.71, 0, 0);
  transform: matrix(0.71, 0.71, -0.71, 0.71, 0, 0);
  position: relative;
  /* top: -2px; */
  /* position: absolute;*/
  top: 50%;
  /* right: 5px; */
  margin-top: -4px;
}

.btn-hover {
  color: rgba(255, 255, 255, 0.6);
  background-color: #179b16;
}

.expressType2 {
  border: 1px solid #ff8605;
  color: #ff8605;
  font-size: 10px;
  width: auto;
  height: auto;
  line-height: 1.5;
  text-align: center;
  margin-left: 5px;
  border-radius: 3px;
  padding-left: 3px;
  padding-right: 3px;
  margin: 5px;
}

.expressType1 {
  border: 1px solid #007de4;
  color: #007de4;
  font-size: 10px;
  width: auto;
  height: auto;
  line-height: 1.5;
  text-align: center;
  margin-left: 5px;
  border-radius: 3px;
  padding-left: 3px;
  padding-right: 3px;
  margin: 5px;
}

.title_left {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
  margin-left: 10px;
}

.apply-title-center {
  background-color: white;
  border-bottom: 1px solid #ddd;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
  flex-direction: row;
  -webkit-flex-direction: row;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  height: fit-content;
}

// service
.hos_info {
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: #fff;
}

.hos_logo_big {
  width: 80px;
  height: 80px;
  margin: 10px auto;
  margin-top: 20px;
}

.hos_name {
  font-size: 17px;
  font-weight: bold;
  text-align: center;
}

.switch_btn {
  margin: 5px auto;
}

.mr_type_cell {
  margin-top: 10px;
  width: 100%;
  background-color: #fff;
  text-align: left;
}

.mrType_desc {
  font-size: 15px;
  color: #333;
  padding-top: 20px;
  text-align: center;
}

.mr_cell {
  width: 33.33336%;
  text-align: center;
  display: inline-block;
  margin-top: 10px;
  margin-bottom: 10px;
}

.mr_item3 {
  border: 1px solid #88ceff;
  background-color: #f7fdff;
  width: 86%;
  height: 80px;
  text-align: center;
  margin: 0 auto;
  align-self: center;
}

.mr_item1 {
  border: 1px solid #86d085;
  background-color: #f9fff9;
  width: 86%;
  height: 80px;
  text-align: center;
  margin: 0 auto;
  align-self: center;
}

.mr_item2 {
  border: 1px solid #ffc07e;
  background-color: #fffcfa;
  width: 86%;
  height: 80px;
  text-align: center;
  margin: 0 auto;
  align-self: center;
}

.mr_item_icon {
  width: 20px;
  height: 20px;
  margin-top: 10px;
}

.mr_item_name {
  font-size: 15px;
  margin-bottom: 10px;
}

.multi-hos_tips {
  background: #effbff;
  display: flex;
  display: -webkit-flex;
  /* Safari */
  padding: 10px;
}

.multi-hos_tips_content {
  color: #333;
  font-size: 15px;
}

.select_hos {
  color: #1aac19;
  font-size: 15px;
  font-weight: bold;
}

.weui-btn_mini {
  font-size: 14px;
  border-radius: 25%;
}

.stress {
  color: #f00;
}
.no_display {
  display: none;
}
.desc_cell {
  display: flex;
  font-size: 14px;
  padding: 10px 15px;
  background-color: #fff;
}

// 新地址业务
.myAddress {
  width: 100%;
  background-color: white;
  border-top: 4px solid rgba(245, 245, 245, 1);
  color: #333;
}
.myAddress .cont {
  border-bottom: 1px solid rgba(245, 245, 245, 0.8);
}
.myAddress .cont span {
  display: inline-block;
  font-size: 0.28rem;
  color: #333;
  line-height: 0.88rem;
  margin-left: 0.32rem;
}
.myAddress .cont section {
  float: left;
}
.myAddress .cont p {
  display: inline-block;
  font-size: 0.28rem;
  color: #333333;
  line-height: 0.88rem;
  margin-left: 1rem;
}
.myAddress .cont .pic2 {
  float: right;
  width: 0.14rem;
  height: 0.24rem;
  margin: 0.32rem 0.32rem 0.32rem 0;
}
.myAddress .cont p.text {
  margin-left: 0.72rem;
}
.showChose {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 120;
  background: rgba(77, 82, 113, 0.8);
}
.address {
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 121;
  background: #fff;
  width: 100%;
}

.title1 .tipadd {
  display: inline-block;
  margin-left: 0.8rem;
  font-size: 1rem;
  line-height: 2rem;
  font-weight: bold;
  color: #333;
}
.title1 .greentip{
  color: #999;
  font-size:0.8rem;
  font-weight: normal;
}
.title1 span {
  // margin: 0.42rem 0 0 16rem;
  display: inline-block;
  font-size: 2rem;
  line-height: 1.8rem;
  color: #d8d8d8;
  margin-right: 10px;
}
.selectarea{
  margin-top: 10px;
  margin-bottom: 10px;
  box-shadow: 0px 2px 3px #ebebeb;
  padding-bottom: 10px;
}
.area {
  display: inline-block;
  font-size: 1.2rem;
  // line-height: 4rem;
  margin-left: 0.8rem;
  color: #1aac19;
}
.addList {
  width: 100%;
  padding-left: 0.8rem;
  font-size: 1.2rem;
  line-height: 2rem;
  color: #333;
}
/* 修改的格式 */
.address ul {
  width: 95%;
  height: 100%;
  height: 30rem;
  overflow: auto;
}
// .address ul li {
//   margin-left: 5%;
// }
.address .title1 .active {
  color: #333333;
  border-bottom: 0.02rem solid #333333;
}
.address ul .active {
  color: #333333;
}
.jusbetween{
  display: flex;
  justify-content: space-between;
}
// 新地址业务
</style>
